'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actions = [{
    type: 'I18N_INIT',
    propTypes: {
        uxMode: _proptypes2.default.bool.isRequired,
        localeData: _proptypes2.default.object,
        secondarySwitched: _proptypes2.default.bool.isRequired,
        uxLanguage: _proptypes2.default.string.isRequired,
        secondChoiceLocale: _proptypes2.default.string
    }
}, {
    type: 'I18N_REQUEST_CHANGE',
    propTypes: {
        organizationLocale: _proptypes2.default.string.isRequired,
        countryCode: _proptypes2.default.string.isRequired
    }
}, {
    type: 'I18N_VIEW_READY_FOR_CHANGE',
    propTypes: {
        localeData: _proptypes2.default.object.isRequired,
        skipLocaleSideEffect: _proptypes2.default.bool
    }
}, {
    type: 'I18N_SWITCH_TO_SECONDARY'
}, {
    type: 'I18N_CHANGE_LOCALE'
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions, 'I18N_ACTIONS_');
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions, 'I18N_ACTIONS_');


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/actions/I18nActions.js
// module id = 169
// module chunks = 0